export const EncryptKeys = ['latitude', 'longitude'];
